import React from "react";
import PropTypes from "prop-types";
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "33vh",
  },
}));

const Loader = ({ color, containerProps, color2, ...rest }) => {
  const classes = useStyles();
  return (
    <div className={classes.root} {...containerProps} style={{backgroundColor:color2}}>
      <CircularProgress color={color} />
    </div>
  );
};

Loader.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
};

export default Loader;
